import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { OktaService } from '@engie-group/ngx-gem-spaas';
import { DataGridsHelper } from 'src/app/core/data-grids-helper';
import { ResIntructionType } from 'src/app/core/Dtos/res/instructions-dto';
import { ResInstructionsGridDTO } from 'src/app/core/Dtos/res/instructions-grid-dto';
import { AlertsService } from 'src/app/core/services/alerts.service';
import { DateFormatHelperService } from 'src/app/core/services/date-format-helper.service';
import { BaseComponent } from 'src/app/features/base-component';

@Component({
  selector: 'app-res-instructions',
  templateUrl: './res-instructions.component.html',
  styleUrl: './res-instructions.component.scss',
  standalone: false
})
export class ResInstructionsComponent extends BaseComponent {
  @Output()
  public OnViewInstruction: EventEmitter<string | number> = new EventEmitter<string | number>();
  @Output() public OnCopyToNew: EventEmitter<string | number> = new EventEmitter<string | number>();

  @Input("GridData") public set CurrentSearchData(data: ResInstructionsGridDTO[]) {
    this.DataGridHelper.GridData = data;
  }
  public ResIntructionType = ResIntructionType;
  public DataGridHelper: DataGridsHelper<ResInstructionsGridDTO> = new DataGridsHelper<ResInstructionsGridDTO>();

  constructor(
    dateFormatHelper: DateFormatHelperService,
    oktaService: OktaService,
    private _router: Router,
    alertService: AlertsService) {
    super(oktaService, alertService, dateFormatHelper)
  }

  public ViewInstruction(instructionId: number | string) {
    this.OnViewInstruction?.next(instructionId);
  }

  public CopyToNew(instructionId: number | string) {
    this.OnCopyToNew?.next(instructionId);
  }

  public GetClass(startDate: Date | string, endDate: Date | string) {
    let sd = new Date(startDate),
      ed = (endDate ?? "") == "" ? null : new Date(endDate),
      today = new Date();

    if (today > sd && (ed == null || today < ed))
      return "day-instruction";

    return "";
  }
}
